import React, { useCallback, useEffect, useState } from 'react'
import { Button, Mask, Toast } from 'antd-mobile-v5'
import { useHasLogin, useSignDivingAgreement } from '../../services/hooks'
import { useGrantBadge } from '../../services/hooks/club'
import styles from './OceanConventionDailyPopup.module.css'

const OceanConventionDailyPopup = () => {
  // 状态管理
  const [visible, setVisible] = useState(false)
  const [checked, setChecked] = useState(false)

  // Hooks
  const { data } = useHasLogin(
    {
      manual: false,
    },
    'detail'
  )

  const { run: signDivingAgreement } = useSignDivingAgreement({
    onSuccess: () => {
      if (checked) {
        grantBadge({ badgeType: 1 })
      } else {
        setVisible(false)
      }
    },
    onError: () => {
      Toast.show({
        icon: 'fail',
        content: '提交失败，请稍后重试',
      })
    },
  })

  const { run: grantBadge } = useGrantBadge({
    onSuccess: () => {
      setVisible(false)
      Toast.show({
        icon: 'success',
        content: '徽章授予成功',
      })
    },
    onError: () => {
      setVisible(false)
      Toast.show({
        icon: 'fail',
        content: '徽章授予失败，请稍后重试',
      })
    },
  })

  // 监听数据变化，控制弹窗显示
  useEffect(() => {
    setVisible(!!data?.divingAgreementPopup)
  }, [data])

  // 处理承诺提交
  const handleCommit = useCallback(() => {
    signDivingAgreement()
  }, [signDivingAgreement])

  // 处理复选框变化
  const handleCheckboxChange = useCallback((e) => {
    setChecked(e.target.checked)
  }, [])

  return (
    <Mask visible={visible} className={styles.mask}>
      <div className={styles['popup-container']}>
        {/* 徽章图片 */}
        <div className={styles['logo-container']}>
          <img
            src={require('../../assets/images/publicWelfareEcard/ocean_badge.jpg')}
            alt="ocean badge"
            className={styles['logo-img']}
          />
        </div>

        {/* 标题 */}
        <h2 className={styles.title}>为蔚蓝海洋，我承诺：</h2>

        {/* 承诺内容 */}
        <div className={styles['content-container']}>
          <div className={styles['promise-item']}>
            <div className={styles['promise-text']}>
              <span role="img" aria-label="勾选">
                ✅
              </span>{' '}
              在规则中潜水：严守标准，珍视安全，
            </div>
            <div className={styles['promise-subtext']}>绝不逾越红线。</div>
          </div>
          <div className={styles['promise-item']}>
            <div className={styles['promise-text']}>
              <span role="img" aria-label="勾选">
                ✅
              </span>{' '}
              在敬畏中探索：尊重生命，守护蔚蓝，
            </div>
            <div className={styles['promise-subtext']}>绝不触碰伤害。</div>
          </div>
          <div className={styles['promise-text']}>安全是我的信仰，海洋是我的责任。</div>
        </div>

        {/* 复选框 */}
        <div className={styles.checkbox}>
          <label className={styles['checkbox-label']}>
            <input
              type="checkbox"
              className={styles['checkbox-input']}
              checked={checked}
              onChange={handleCheckboxChange}
            />
            <span>申请成为 PADI Torchbearer，即可在“我的-里程碑”获取徽章</span>
          </label>
        </div>

        {/* 提交按钮 */}
        <Button color="primary" fill="solid" onClick={handleCommit} className={styles['commit-button']}>
          我承诺
        </Button>
      </div>
    </Mask>
  )
}

export default OceanConventionDailyPopup
